module.exports = __webpack_public_path__ + "static/media/rinfo.75e14504.png";